import '@fontsource-variable/onest';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { installChunkReloadGuard, sendBootBeacon } from '@flagships/rails-frontend';
import App from './App.vue';
import { buildRouter } from './router';
import './style.css';

const router = buildRouter();
installChunkReloadGuard(router);
createApp(App).use(createPinia()).use(router).mount('#app');
router.isReady().then(() => {
  sendBootBeacon('/api', 'ready', 'metrika', import.meta.env.VITE_APP_VERSION ?? '');
  (window as unknown as { __fsBooted?: boolean }).__fsBooted = true;
});
